import React from "react";
import { Warning, Unauthorised, Missing } from "components/Shared";
import _ from "lodash";

const Error = ({ resource }: { resource: any }) => {
	if (_.get(resource, "response.status") === 403 || _.get(resource, "response.status") === 401) {
		return <Unauthorised />;
	} else if (_.get(resource, "response.status") === 404) {
		return <Missing />;
	}
	return <Warning />;
};

export default Error;
